import {z} from 'zod';

export const createSupplierOrderFormSchema = (
  isOrderTypeRequired: boolean,
  isSupplierAccountRequired: boolean
) =>
  z.object({
    orderVariantId: z.string(),
    supplierId: z.string(),
    orderType: isOrderTypeRequired ? z.string() : z.string().nullish(),
    supplierAccountCode: isSupplierAccountRequired ? z.string() : z.string().nullish(),
  });

export type CreateSupplierOrderFormType = z.infer<ReturnType<typeof createSupplierOrderFormSchema>>;
